import {getModule, Module, Mutation, VuexModule, Action} from 'vuex-module-decorators';
import store from '..';
import {IOrganization} from '@/models/IOrganization';
import {getListOrganizations} from '@/services/OrganizationService';

@Module({name: 'organization', store, dynamic: true})
export class OrganizationModule extends VuexModule {
    public organizationId: number = 0;
    public organizations: any = [];

    @Mutation
    public setOrganizationId(organizationId: number) {
        this.organizationId = organizationId;
    }

    @Mutation
    public setOrganizations(organizations: IOrganization) {
        this.organizations = organizations;
    }

    @Action
    public async getListOrganization() {
        const response = await getListOrganizations();
        this.context.commit('setOrganizations', response);
    }
}

export const ModuleOrganization = getModule(OrganizationModule);
